/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_appsync_graphqlEndpoint": "https://6hg6c7wq4fg2bi53yfhg475fyu.appsync-api.ap-southeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-7trmqfwaozdpdizfbt6zokz6sm",
    "aws_cloud_logic_custom": [
        {
            "name": "SyncApi",
            "endpoint": "https://ctdwmdoos2.execute-api.ap-southeast-1.amazonaws.com/gs",
            "region": "ap-southeast-1"
        }
    ],
    "aws_cognito_identity_pool_id": "ap-southeast-1:bf669ab0-b531-4739-b1c3-6648ad580a59",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_cYFJS6LY6",
    "aws_user_pools_web_client_id": "66gmrb38q2nr4m7mbd38tll5q5",
    "oauth": {
        "domain": "pretepop-gs.auth.ap-southeast-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://a-gs.pretepop.com/",
        "redirectSignOut": "https://a-gs.pretepop.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_user_files_s3_bucket": "storage92651-gs",
    "aws_user_files_s3_bucket_region": "ap-southeast-1"
};


export default awsmobile;
